const { default: Swiper } = require('swiper');
import { Scrollbar } from 'swiper/modules';

const sections = document.querySelectorAll('section.blog-block');

if (sections.length) {
    Swiper.use([Scrollbar]);
    sections.forEach(element => {
        const sliderElement = element.querySelector('.js-blog-block-slider');
        const scrollbar = element.querySelector('.slider-scrollbar');
        let swiper = null;

        function initSwiper() {
            if (window.innerWidth <= 991.98 && !swiper) {
                swiper = new Swiper(sliderElement, {
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                    scrollbar: {
                        el: scrollbar,
                        dragClass: 'slider-scrollbar__drag',
                        draggable: true,
                    },
                });
            } else if (window.innerWidth > 991.98 && swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }

        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
}
